import { apiRoot } from '../apiInstances';

export const timeEntriesApi = {
  list: async (woId: number, lineId: number) => {
    const { data } = await apiRoot.get(
      `/work-orders/${woId}/line-items/${lineId}/time-entries`
    );
    return data as any[];
  },

  start: async (
    woId: number,
    lineId: number,
    technician_id: number,
    notes?: string
  ) => {
    const { data } = await apiRoot.post(
      `/work-orders/${woId}/line-items/${lineId}/time-entries`,
      { technician_id, action: 'start', notes }
    );
    return data;
  },

  stop: async (
    woId: number,
    lineId: number,
    technician_id: number,
    notes?: string
  ) => {
    const { data } = await apiRoot.post(
      `/work-orders/${woId}/line-items/${lineId}/time-entries`,
      { technician_id, action: 'stop', notes }
    );
    return data;
  },
};
